// @mui
import { Stack, Box } from '@mui/material';
// config
import PropTypes from 'prop-types';
import { NAV } from '../../../config-global';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';
// components
import Logo from '../../../components/logo/MobileLogo';
import { NavSectionMini } from '../../../components/nav-section';
//
// import navConfig from './config-navigation';
import NavToggleButton from './NavToggleButton';
import useNavConfig from './useNavConfig';
import NavRelationshipManager from './NavRelationshipManager';

// ----------------------------------------------------------------------
NavMini.propTypes = {
  faviconLogo: PropTypes.string,
};

export default function NavMini({ faviconLogo }) {
  const navConfig = useNavConfig();
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
        }}
      >
        {/* Only this part scrolls, so the relationship manager below stays pinned. */}
        <Stack sx={{ flexGrow: 1, minHeight: 0, ...hideScrollbarX }}>
          <Logo sx={{ mx: 'auto', my: 2 }} landingLogo={faviconLogo} />

          <NavSectionMini data={navConfig} />
        </Stack>

        <NavRelationshipManager compact />
      </Stack>
    </Box>
  );
}
